import React, { Component } from 'react';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import Popover from '../../../base/popover/components/Popover.web';
import HangupToggleButton from './HangupToggleButton';
/**
 * A React {@code Component} for opening or closing the {@code HangupMenu}.
 *
 * @augments Component
 */
class HangupMenuButton extends Component {
    /**
     * Initializes a new {@code HangupMenuButton} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this._onCloseDialog = this._onCloseDialog.bind(this);
        this._toggleDialogVisibility
            = this._toggleDialogVisibility.bind(this);
        this._onEscClick = this._onEscClick.bind(this);
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onCloseDialog();
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { ariaControls, children, isOpen, menuLabel, t } = this.props;
        return (React.createElement("div", { className: 'toolbox-button-wth-dialog context-menu' },
            React.createElement(Popover, { content: children, headingLabel: menuLabel || t('toolbar.accessibilityLabel.hangup'), onPopoverClose: this._onCloseDialog, position: 'top', trigger: 'click', visible: isOpen },
                React.createElement(HangupToggleButton, { ariaControls: ariaControls ? String(ariaControls) : undefined, ariaHasPopup: 'dialog', buttonKey: 'hangup-menu', customClass: 'hangup-menu-button', handleClick: this._toggleDialogVisibility, isMenuButton: true, isOpen: isOpen, menuLabel: menuLabel, notifyMode: this.props.notifyMode, onKeyDown: this._onEscClick }))));
    }
    /**
     * Callback invoked when {@code InlineDialog} signals that it should be
     * close.
     *
     * @private
     * @returns {void}
     */
    _onCloseDialog() {
        this.props.onVisibilityChange(false);
    }
    /**
     * Callback invoked to signal that an event has occurred that should change
     * the visibility of the {@code InlineDialog} component.
     *
     * @private
     * @returns {void}
     */
    _toggleDialogVisibility() {
        sendAnalytics(createToolbarEvent('hangup'));
        this.props.onVisibilityChange(!this.props.isOpen);
    }
}
export default translate(HangupMenuButton);
